<template>
  <div>
    <vx-card no-shadow>
      <vs-row vs-justify="space-between" class="mb-5">
        <vs-col vs-w="6">
          <h3 class="mr-4">Cookie popup</h3>
          <p class="mt-5">Details about the cookie popup can be specified here.</p>
        </vs-col>
      </vs-row>
      <vs-row vs-align="center">
        <span>Switch language for all</span>
        <vs-dropdown vs-trigger-click class="cursor-pointer items-per-page-handler">
          <div
            style="padding: 0.8rem !important"
            class="
              ml-2
              mr-2
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <img class="h-4 w-5" :src="i18n_locale_img" :alt="locale" />
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu class="w-48">
            <vs-dropdown-item @click="updateLocale('eng')">
              <img class="h-4 w-5 mr-1" src="@/assets/images/flags/eng.png" alt="eng" />
              &nbsp;English
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('dan')">
              <img class="h-4 w-5 mr-1" src="@/assets/images/flags/dan.png" alt="eng" />
              &nbsp;Danish
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('swe')">
              <img class="h-4 w-5 mr-1" src="@/assets/images/flags/swe.png" alt="eng" />
              &nbsp;Swedish
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('nor')">
              <img class="h-4 w-5 mr-1" src="@/assets/images/flags/nor.png" alt="eng" />
              &nbsp;Norwegian
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('fin')">
              <img class="h-4 w-5 mr-1" src="@/assets/images/flags/fin.png" alt="eng" />
              &nbsp;Finnish
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </vs-row>
      <vs-row v-if="settings" vs-w="8">
        <h4 class="mt-5">Header</h4>
        <CookieSettingRow title="Header text">
          <i8n-input :content.sync="settings.header_text" />
        </CookieSettingRow>

        <h4 class="mt-5">Buttons</h4>
        <CookieSettingRow title="Adjust">
          <i8n-input :content.sync="settings.button_adjust" />
        </CookieSettingRow>
        <CookieSettingRow title="Accept necessary">
          <i8n-input :content.sync="settings.button_acceptnecessary" />
        </CookieSettingRow>
        <CookieSettingRow title="Accept chosen">
          <i8n-input :content.sync="settings.button_acceptchosen" />
        </CookieSettingRow>
        <CookieSettingRow title="Accept all">
          <i8n-input :content.sync="settings.button_acceptall" />
        </CookieSettingRow>
        <CookieSettingRow title="Back">
          <i8n-input :content.sync="settings.button_back" />
        </CookieSettingRow>

        <h4 class="mt-5">Cookie categories</h4>
        <CookieSettingRow title="Essential">
          <i8n-input :content.sync="settings.category_Essential" />
        </CookieSettingRow>
        <CookieSettingRow title="Preferences">
          <i8n-input :content.sync="settings.category_Preferences" />
        </CookieSettingRow>
        <CookieSettingRow title="Analytics">
          <i8n-input :content.sync="settings.category_Analytics" />
        </CookieSettingRow>
        <CookieSettingRow title="Marketing">
          <i8n-input :content.sync="settings.category_Marketing" />
        </CookieSettingRow>
        <CookieSettingRow title="Unclassified">
          <i8n-input :content.sync="settings.category_Unclassified" />
        </CookieSettingRow>

        <h4 class="mt-5">Cookie descriptions</h4>
        <CookieSettingRow title="Name">
          <i8n-input :content.sync="settings.cookie_name" />
        </CookieSettingRow>
        <CookieSettingRow title="Vendor">
          <i8n-input :content.sync="settings.cookie_vendor" />
        </CookieSettingRow>
        <CookieSettingRow title="Method">
          <i8n-input :content.sync="settings.cookie_method" />
        </CookieSettingRow>
        <CookieSettingRow title="Expires">
          <i8n-input :content.sync="settings.cookie_expiry" />
        </CookieSettingRow>
        <CookieSettingRow title="Type">
          <i8n-input :content.sync="settings.cookie_type" />
        </CookieSettingRow>
        <CookieSettingRow title="Purpose">
          <i8n-input :content.sync="settings.cookie_purpose" />
        </CookieSettingRow>

        <h4 class="mt-5">General</h4>
        <CookieSettingRow title="Text 'Yes'">
          <i8n-input :content.sync="settings.text_yes" />
        </CookieSettingRow>
        <CookieSettingRow title="Text 'No'">
          <i8n-input :content.sync="settings.text_no" />
        </CookieSettingRow>
        <CookieSettingRow title="Full policy link">
          <i8n-input :content.sync="settings.read_policy_link" />
        </CookieSettingRow>

        <h4 class="mt-5">Cookie brief policy</h4>
        <CookieSettingRow title="">
          <i8n-quill-editor :content.sync="settings.brief_cookie_policy" />
        </CookieSettingRow>

        <h4 class="mt-5">Cookie policy</h4>
        <CookieSettingRow title="">
          <i8n-quill-editor :content.sync="settings.cookie_policy" />
        </CookieSettingRow>
      </vs-row>
      <vs-row vs-justify="flex-end" class="flex flex-wrap items-center" style="margin-top: 32px">
        <!-- <vs-button id="save-button"  v-if="hasPermission('vp.crm.legaldocuments.edit')" @click="update" class="mt-2">Save Changes</vs-button> -->
        <!-- TODO IDAM permission -->
        <vs-button id="save-button" @click="update" class="mt-2">Save Changes</vs-button>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CookieSettingRow from "./CookieSettingRow.vue";

export default {
  components: { CookieSettingRow },
  data() {
    return {
      locale: "eng",
    };
  },
  methods: {
    async update() {
      try {
        this.$vs.loading();
        await this.$store.dispatch("cookiePopup/update", this.settings);
        this.$vs.notify({
          color: "green",
          title: "Cookie popup settings updated",
          text: "The settings was successfully updated",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Cookie settings update error",
          text: err,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    updateLocale(locale) {
      this.locale = locale;
      this.$root.$emit("changedLocale", locale);
    },
  },
  computed: {
    ...mapGetters({
      settings: "cookiePopup/cookiePopupSettings",
    }),
    i18n_locale_img() {
      return require(`@/assets/images/flags/${this.locale}.png`);
    },
  },
  async mounted() {
    await this.$store.dispatch("cookiePopup/get");
  },
};
</script>
